import { api, el } from './dom.js';

const STORAGE_KEY = 'mc-ux-feedback';

function answeredPages() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; }
}

function rememberAnswer(page) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set([...answeredPages(), page])])); } catch { /* sem storage: pergunta de novo */ }
}

// "Esta página foi fácil de usar?" — alimenta o ciclo de revisão da interface
// (docs/melhor-cron-ux-review.md). Um voto por página por navegador.
export function mountUxFeedback(host, page) {
  if (!host) return;
  if (answeredPages().includes(page)) {
    host.replaceChildren(el('p', { className: 'mc-muted', text: 'Obrigado pela avaliação desta página.' }));
    return;
  }
  const comment = el('textarea', { maxlength: '500', rows: '2', placeholder: 'O que ficou confuso ou faltou? (opcional)', 'aria-label': 'Comentário' });
  const status = el('p', { className: 'mc-message', role: 'status' });
  let helpful = null;
  const send = async () => {
    try {
      await api('/api/tools/cron-calculator/ux-feedback', { method: 'POST', body: JSON.stringify({ page, helpful, comment: comment.value.trim() }) });
      rememberAnswer(page);
      host.replaceChildren(el('p', { className: 'mc-muted', text: 'Obrigado! Sua resposta ajuda a melhorar esta página.' }));
    } catch (error) {
      status.textContent = error.message;
      status.dataset.tone = 'error';
    }
  };
  const details = el('div', { className: 'mc-feedback-details', hidden: true }, [
    comment,
    el('div', { className: 'mc-form-actions' }, [el('button', { type: 'button', className: 'primary', text: 'Enviar', onclick: send })]),
    status
  ]);
  const choose = (value) => {
    helpful = value;
    yes.setAttribute('aria-pressed', String(value));
    no.setAttribute('aria-pressed', String(!value));
    comment.placeholder = value ? 'Algo que poderia ficar ainda melhor? (opcional)' : 'O que ficou confuso ou faltou? (opcional)';
    details.hidden = false;
    comment.focus();
  };
  const yes = el('button', { type: 'button', className: 'mc-secondary', 'aria-pressed': 'false', text: '👍 Sim', onclick: () => choose(true) });
  const no = el('button', { type: 'button', className: 'mc-secondary', 'aria-pressed': 'false', text: '👎 Não', onclick: () => choose(false) });
  host.replaceChildren(
    el('div', { className: 'mc-feedback-ask' }, [el('strong', { text: 'Esta página foi fácil de usar?' }), el('div', { className: 'mc-form-actions' }, [yes, no])]),
    details
  );
}
